export default "/images/chevron-down-icon.svg?428965cc66458ceb01f0fc0c22e6601a";